import { render, staticRenderFns } from "./SendedCi.vue?vue&type=template&id=0da08dd7&"
import script from "./SendedCi.vue?vue&type=script&lang=js&"
export * from "./SendedCi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports